import { ApplicationConfig, Injector, inject, provideAppInitializer } from '@angular/core'
import { ActivatedRoute, provideRouter } from '@angular/router'

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { provideAnimations } from '@angular/platform-browser/animations'
import { AuthInterceptor } from '@cr-driver/handler/auth.interceptor'
import { MonthNamePipe } from '@cr-driver/month-name.pipe'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { provideOAuthClient } from 'angular-oauth2-oidc'
import { TranslationFactory } from 'projects/charge-repay-driver/src/app/core/config/translation.config'
import { routes } from './app.routes'

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      routes
      // withDebugTracing()
    ),
    provideAnimations(),
    provideOAuthClient(),
    {
      provide: MonthNamePipe,
    },
    TranslateModule.forRoot({
      fallbackLang: 'en-GB',
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    }).providers!,
    provideAppInitializer(() => {
      const initializerFn = TranslationFactory(inject(TranslateService), inject(ActivatedRoute), inject(Injector))
      return initializerFn()
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
}
